import { Injectable, signal } from '@angular/core';
import {
  DocTemplate,
  type DocField,
  type FieldAnchor,
  type FieldValue,
} from '../../_lib/docx-core';

@Injectable()
export class DocStore {
  public readonly fields = signal<readonly DocField[]>([]);
  public readonly fileName = signal('');
  public readonly failed = signal(false);
  public readonly busy = signal(false);

  private template: DocTemplate | null = null;

  public isOpen(): boolean {
    return this.template !== null;
  }

  public async open(file: File): Promise<void> {
    this.busy.set(true);
    this.failed.set(false);

    try {
      this.template = await DocTemplate.open(file);
      this.fileName.set(file.name);
      this.fields.set(this.template.fields());
    } catch (cause) {
      this.template = null;
      this.fields.set([]);
      this.failed.set(true);
      console.error('Failed to open docx', cause);
    } finally {
      this.busy.set(false);
    }
  }

  public setValue(id: string, value: FieldValue): void {
    if (!this.template) {
      return;
    }

    this.template.setValue(id, value);
    this.fields.set(this.template.fields());
  }

  public async render(body: HTMLElement, styles: HTMLElement): Promise<readonly FieldAnchor[]> {
    if (!this.template) {
      return [];
    }

    return this.template.renderTo(body, styles);
  }

  public toFile(): File | null {
    if (!this.template) {
      return null;
    }

    const blob = this.template.toBlob();

    return new File([blob], this.fileName(), { type: blob.type });
  }
}
